var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTongyongFujian(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.684 3.926L4.985 9.624a.971.971 0 000 1.374v0c.38.38.995.38 1.374 0l5.901-5.901a1.943 1.943 0 000-2.748v0a1.943 1.943 0 00-2.747 0L3.05 8.813a2.917 2.917 0 000 4.124v0a2.917 2.917 0 004.124 0l6.26-6.26",
    stroke: "#3F465C",
    strokeLinecap: "round"
  })));
}
export default __webpack_public_path__ + "static/tongyong_fujian.39efe63a.svg";
export { SvgTongyongFujian as ReactComponent };